import {
  fun_PostAction,
  fun_GetAction,
  fun_UploadImg,
  fun_Download
} from "@/api/index";
// 引入转译方法
import { fun_DownloadFile } from "@/utils/validate";
import PDFDialog from "../../components/pdfDialog/index.vue";
export default {
  data() {
    return {
      // 全局加载
      fullLoading: null,
      // 折叠面板
      activeNames: ["1"],
      // 默认关闭
      dialogVisible: false,
      // 图片预览dialog
      imgVisible: false,
      // 加载
      loading: false,
      // 表头按钮组
      btnList: [
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 查询表单绑定值
      form: {
        type: null, // 类型
        pictureType: null, // 图片类型
        pictureName: null, // 文件名称
        recordNumber: null, // 数据编号
        secondaryNumber: null // 次级关联主键
      },
      // 查询表单基础数据
      formSearchList: [],
      // 表格基础数据
      tableColumns: [
        {
          label: "上传文件名",
          prop: "pictureName"
        },
        {
          label: "图片类型",
          prop: "pictureTypeName"
        },
        {
          label: "上传时间",
          prop: "insertDate"
        },
        {
          label: "操作",
          slotName: "operation",
          width: 180
        }
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
      pictureTypes: [], // 图片类型下拉框的值
      pictureFiles: [], // 文件
      // 图片路径
      imgUrl: null,
      // 图片压缩.zip的文件路径
      fileUrl: null
    };
  },
  // 接收父组件传递的数据
  props: {
    // 页面类型
    controllerFlg: {
      type: String
    },
    // 文件类型
    type: {
      type: String,
      default: ""
    },
    // 数据编号
    recordNumber: {
      type: String
    },
    // 次级关联主键
    secondaryNumber: {
      type: String
    },
    // 图片类型
    pictureType: {
      type: String
    },
    // 额外类型判断
    otherType: {
      type: String
    }
  },
  watch: {
    // 监听父组件传递的数据 图片类型
    pictureType: {
      // handler监听改变之后的值、改变之前的值
      handler(newVal) {
        // 如果有改变的值
        if (newVal) {
          // 设置表单中的数据编号
          this.form.pictureType = newVal;
        }
      },
      immediate: true, // 立即执行
    },
    // 监听父组件传递的数据 数据编号
    recordNumber: {
      // handler监听改变之后的值、改变之前的值
      handler(newVal) {
        // 如果有改变的值
        if (newVal) {
          // 设置表单中的数据编号
          this.form.recordNumber = newVal;
        }
      },
      immediate: true, // 立即执行
    },
    // 监听父组件传递的数据 次级关联主键
    secondaryNumber: {
      // handler监听改变之后的值、改变之前的值
      handler(newVal) {
        // 如果有改变的值
        if (newVal) {
          // 设置表单中的数据编号
          this.form.secondaryNumber = newVal;
        }
      },
      immediate: true, // 立即执行
    },
    // 监听父组件传递的数据 文件类型
    type: {
      // handler监听改变之后的值、改变之前的值
      handler(newVal) {
        // 如果有改变的值
        if (newVal) {
          // 赋值
          this.form.type = newVal;
          // 设置表头
          this.fun_SetTableColumns(newVal);
          // 查询一览数据
          this.fun_GetList();
        }
      },
      immediate: true, // 立即执行
    },
    // 监听父组件传递的数据 页面类型
    controllerFlg: {
      // handler监听改变之后的值、改变之前的值
      handler(newVal) {
        // 判断是否是查看详情
        if (newVal === "details" || newVal === "detail") {
          // 清空表头按钮
          this.btnList = [];
        }
      },
      immediate: true, // 立即执行
    },
  },
  // 注册组件
  components: {
    PDFDialog
  },
  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    // 打开弹框时调用
    fun_GetOpen() {
      // 获取图片压缩.zip的路径
      this.fun_GetFileUrl();
      // 查询一览数据
      this.fun_GetList();
    },
    /**
     * 获取图片压缩.zip的路径
     * @author shuhua
     */
    fun_GetFileUrl() {
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: "图片压缩"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 图片压缩.zip的路径
          this.fileUrl = data;
        }
      });
    },
    /**
     * 设置表头
     * @author shuhua
     */
    fun_SetTableColumns(type) {
      // 上传图片类型是基本信息,注册人基本信息,交易人业绩,交易人奖惩记录,交易人银行基本户
      if (type === "1" || type === "5" || type === "7" || type === "8" || type === "9" ||
        // 交易人惩罚,注册人奖励,注册人惩罚,注册人业绩
        type === "26" || type === "27" || type === "28" || type === "29") {
        // 设置表单
        this.tableColumns = [
          {
            label: "图片类型",
            prop: "pictureTypeName"
          },
          {
            label: "上传文件名",
            prop: "pictureName"
          },
          {
            label: "状态",
            slotName: "state"
          },
          {
            label: "电子签名",
            slotName: "digitalSignature"
          },
          {
            label: "操作",
            slotName: "operation",
            width: 180
          }
        ];
      }
      // 图片类型是中标公示撤回附件
      else if (type === "33") {
        // 设置表头
        this.tableColumns = [
          {
            label: "上传文件名",
            prop: "pictureName"
          },
          {
            label: "操作",
            slotName: "operation",
            width: 180
          }
        ];
      }
      // 图片类型是专家评委抽选登记表附件
      else if (type === "37") {
        // 设置表头
        this.tableColumns = [
          {
            label: "上传文件名",
            prop: "pictureName"
          },
          {
            label: "上传时间",
            prop: "insertDate"
          },
          {
            label: "操作",
            slotName: "operation",
            width: 180
          }
        ];
      }
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 请求路径
      let url = "/corpPictureinfor/list";
      // 中标公示撤回附件
      if (this.type === "33") {
        // 请求路径
        url = "/tenderPictureinfor/prequalificationTenderPictureinforList";
      }
      // 图片类型下拉框
      this.fun_GetPictureTypeSelect();
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction(url, {
        ...this.form,
        ...this.reqPageData
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 数据不为空
          if (data) {
            // 回显table
            this.tableData = data.records;
            // 获取分页总条数
            this.total = data.total;
          }
          // 关闭loading
          this.loading = false;
        } else {
          // 错误消息提示
          this.$message.error(msg);
          // 关闭loading
          this.loading = false;
        }
      });
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "删除":
          this.fun_Del();
          break;
        default:
      }
    },
    /**
     * 获取图片类型下拉框
     */
    fun_GetPictureTypeSelect() {
      // 设置字典编号
      let zdid = "";
      // 图片类型不是招标代理备案表，数据库字段修改，黑名单，交易人自动转入
      if ("11" != this.type && "19" != this.type && "31" != this.type && "36" != this.type) {
        // 上传图片类型是基本信息
        if ("1" == this.type) {
          // 设置字典id
          zdid = "201904101835580002";
        }
        // 上传图片类型是注册人基本信息
        else if ("5" == this.type) {
          // 设置字典id
          zdid = "201904111617190005";
        }
        // 上传类型是交易人业绩或者注册人员业绩
        else if ("7" == this.type || "29" == this.type) {
          // 设置字典id
          zdid = "201904121753570002";
        }
        // 上传类型是企业奖励
        else if ("8" == this.type && (this.form.pictureType == "" || this.form.pictureType == null)) {
          // 设置字典id
          zdid = "202110151100220123";
        }
        // 上传图片类型是企业申诉
        else if ("10" == this.type) {
          // 设置字典id
          zdid = "202411181124420004";
        }
        // 上传图片类型是专家上传附件类型
        else if ("38" == this.type) {
          // 设置字典id
          zdid = "202304171536330523";
        }
        // 上传图片类型是招标登记项目批准文件类型
        else if ("42" == this.type) {
          // 设置字典id
          zdid = "202406201501250661";
        }
        // 上传图片类型是纠错文件类型
        else if ("43" == this.type) {
          // 设置字典id
          zdid = "202407171636401395";
        }
        // 注册图片类型
        else {
          // 设置字典id
          zdid = "201904111617410006";
        }
      }
      // 请求，获取结果集
      fun_PostAction("/dataDictionaryEntries/DictionaryCombobox", {
        zdid: zdid
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 图片类型下拉框
          this.pictureTypes = data;
        } else {
          this.$message.error(msg);
        }
      });
      // 如果图片类型不为空
      if (this.pictureType != "" && this.pictureType != null) {
        // 设置图片类型
        this.form.pictureType = this.pictureType;
      }
    },
    /**
     * 删除文件
     */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键集合
        let keys = [];
        // 电子签名标志
        let digitalSignatureFlag = false;
        // 遍历勾选
        for (const index in this.multipleSelection) {
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
          // 如果选择的电子签名为空
          if (
            this.multipleSelection[index].digitalSignature != "" &&
            this.multipleSelection[index].digitalSignature != null
          ) {
            // 改为true
            digitalSignatureFlag = true;
          }
        }
        // 如果存在电子签名不为空的数据
        if (digitalSignatureFlag) {
          // 提示，并清除选中数据
          this.$alert(
            "您选择的数据中存在已进行了电子签名的图片，不能删除！",
            "warning"
          );
          return;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 请求路径
          let url = "/corpPictureinfor/delete";
          // 图片类型等于中标公示撤回附件
          if (this.type === "33") {
            // 请求路径
            url = "/tenderPictureinfor/delete"
          }
          // 请求，获取结果集
          fun_PostAction(url, {
            keys: keys
          }).then(res => {
            // 解构res.data
            const { result, msg } = res.data;
            // 操作成功
            if (result) {
              // 操作成功
              this.$message.success(msg);
              // 刷新表单
              this.fun_GetList();
            } else {
              // 操作成功
              this.$message.error(msg);
            }
          });
        });
      }
      // 如果未进行勾选
      else {
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 文件上传
     */
    fun_FileDetail(file, fileList) {
      // 限制小于5M
      const is5M = file.size / 1024 / 1024 < 5;
      // 判断文件是否小于30MB
      if (!is5M) {
        // 清除验证不通过的文件
        this.fun_ClearFile(file, "fileUpload");
        // 提示错误消息
        this.$message.error("上传的文件大小不可超过5MB");
        // 返回
        return false;
      }
      // 获取文件后缀名
      const suffix = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      // 如果是招标登记上传文件
      if (this.form.type == '42') {
        // 这里限定上传文件文件类型必须为jpg,gif,png,pdf，如果文件类型不符，提示错误信息
        if (suffix != 'jpg' && suffix != 'gif' && suffix != 'png' && suffix != 'pdf') {
          // 清除验证不通过的文件
          this.fun_ClearFile(file, "fileUpload");
          // 提示错误消息
          this.$message.error("错误提示:上传文件应该为jpg，gif，png，pdf格式，请重新选择文件后上传");
          // 返回
          return false;
        }
      } else {
        // 这里限定上传文件文件类型必须为jpg,gif,png，如果文件类型不符，提示错误信息
        if (suffix != 'jpg' && suffix != 'gif' && suffix != 'png') {
          // 清除验证不通过的文件
          this.fun_ClearFile(file, "fileUpload");
          // 提示错误消息
          this.$message.error("错误提示:上传文件应该为jpg，gif，png格式，请重新选择文件后上传");
          // 返回
          return false;
        }
      }
      // 如果上传文件大于1
      if (fileList.length > 1) {
        // 根据下标删除列表中的文件
        this.$refs[fileList].uploadFiles.splice(0, 1);
      }
      // 加入集合
      this.pictureFiles.push(file);
    },
    /**
     * 清空文件
     */
    fun_ClearFile(file, refsName) {
      // 获取上传文件的uid
      const uid = file.uid;
      // 获取超过限制大小文件的下标
      const idx = this.$refs[refsName].uploadFiles.findIndex(
        item => item.uid === uid
      );
      // 清空附件列表
      this.$refs[refsName].uploadFiles.splice(idx, 1);
    },
    /**
     * 文件下载
     */
    fun_Download(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },
    /**
     * 预览
     */
    fun_Preview(e) {
      // 获取文件后缀名
      let suffix = e.pictureName.substring(e.pictureName.lastIndexOf('.') + 1);
      // 如果图片类型是jpg或者png
      if (suffix === "jpg" || suffix === "png" || suffix === "gif") {
        // 预览图片
        this.fun_LookImg(e.picturePath);
      }
    },
    /**
     * 图片预览
     */
    fun_LookImg(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          if (res.data.type === "application/json") {
            this.$message.error("文件不存在！");
            return;
          }
          // 存储this
          const _this = this;
          const data = new Blob([res.data]);
          this.fun_GetBlobToBase64(data).then(res => {
            // 打开弹窗
            this.imgVisible = true;
            // 回显图片
            _this.imgUrl = res;
          });
        }
      });
    },
    /**
     * 转为base64URL
     * @author 滕威
     */
    fun_GetBlobToBase64(blob) {
      return new Promise((resolve, reject) => {
        // 创建文件对象
        const reader = new FileReader();
        reader.onload = e => {
          resolve(e.target.result);
        };
        reader.readAsDataURL(blob);
        reader.onerror = () => {
          reject(new Error("文件流异常！"));
        };
      });
    },
    /**
     * 在线阅读
     */
    fun_PdfLook(e) {
      // 打开弹窗
      this.$refs.pdfDialog.dialogVisible = true;
      // 路径
      this.$refs.pdfDialog.pdfUrl = e;
      // 表头
      this.$refs.pdfDialog.title = "在线阅读";
      // 默认调用
      this.$refs.pdfDialog.fun_GetOpen();
    },
    /**
     * 保存上传附件图片
     */
    fun_Save() {
      // 如果选择的图片名
      if (this.form.pictureName == "" || this.form.pictureName == null) {
        // 提示，并清除选中数据
        this.$alert("文件名不能为空！", "warning");
        return;
      }
      // 如果图片类型是 交易人基本信息表
      if ("1" == this.type) {
        // 如果选择的图片类型为空
        if (this.form.pictureType == "" || this.form.pictureType == null) {
          // 提示，并清除选中数据
          this.$alert("请选择图片类型！", "warning");
          return;
        }
      }
      // 判断是否上传文件
      if (this.pictureFiles.length === 0) {
        // 提示
        this.$alert("请选择文件后上传！", "warning");
        return;
      }
      // 定义formData
      let formData = new FormData();
      // 设置图片名称
      formData.append("pictureName", this.form.pictureName);
      // 设置图片类型
      formData.append("pictureType", this.form.pictureType);
      // 设置数据编号
      formData.append("recordNumber", this.form.recordNumber);
      // 设置次级关联主键
      formData.append("secondaryNumber", this.form.secondaryNumber);
      // 设置图片类型
      formData.append("type", this.type);
      // 设置额外类型
      formData.append("otherType", this.otherType);

      // 如果上传附件不为空
      if (this.pictureFiles.length > 0) {
        // 设置文件
        formData.append("file", this.pictureFiles[0].raw);
      }
      // 请求路径
      let url = "/corpPictureinfor/submit";
      // 图片类型为中标公示撤回附件
      if (this.type == "33") {
        // 请求路径
        url = "/tenderPictureinfor/saveOrUpdate";
      }
      // 打开全局加载
      this.fun_Loading();
      // 请求
      fun_UploadImg(url, formData).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 关闭加载狂
          this.fullLoading.close();
          // 操作成功
          this.$message.success(msg);
          // 清空文件名
          this.form.pictureName = "";
          // 清空文件类型
          this.form.pictureType = "";
          // 清空文件
          this.pictureFiles = [];
          // 刷新表单
          this.fun_GetList();
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
          // 刷新表单
          this.fun_GetList();
        }
        // 关闭loading
        this.loading = false;
      }).catch(err => {
        // 关闭加载狂
        this.fullLoading.close();
      });
    },
    /**
     * 修改图片类型
     */
    fun_ChangeType() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果选择的图片类型为空
        if (this.form.pictureType == "" || this.form.pictureType == null) {
          // 提示，并清除选中数据
          this.$alert("请选择图片类型！", "warning");
          return;
        }
        // 主键集合
        let keys = [];
        // 电子签名标志
        let digitalSignatureFlag = false;
        // 遍历勾选
        for (const index in this.multipleSelection) {
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("确定要修改这些图片的类型吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 打开全局加载
          this.fun_Loading();
          // 请求，获取结果集
          fun_PostAction("/corpPictureinfor/corpPictureChangeType", {
            keys: keys,
            pictureType: this.form.pictureType // 图片类型
          }).then(res => {
            // 关闭加载
            this.fullLoading.close();
            // 解构res.data
            const { msg } = res.data;
            // 清空文件类型
            this.form.pictureType = "";
            // 操作成功
            this.$message.success(msg);
            // 刷新表单
            this.fun_GetList();
          });
        }).catch(err => {
          // 关闭加载狂
          this.fullLoading.close();
        });
      }
      // 如果未进行勾选
      else {
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 全局加载
     * @author liutong
     */
    fun_Loading(val) {
      this.fullLoading = this.$loading({
        lock: true,
        text: val ? val : "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
  }
};
